module.exports = "Haulser/Applicator\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/hauler/templates/main.html
// module id = 787
// module chunks = 0